/**
 * Matcher for custom dimension
 * @module
 */
var _ = require('optimizely-client-fn');

var match = require('core/lib/match');

/**
 * @param {Object} value
 * @param {Object} [value.custom] Map of custom attribute name to value
 * @param {Condition} cond
 */
exports.match = function(value:any, cond:Condition) {
  var customDimensionValue;

  if (value.custom) {
    customDimensionValue = value.custom[cond.name];
  }

  if (_.isObject(customDimensionValue)) {
    customDimensionValue = customDimensionValue.value;
  }

  return match.hasMatch(cond.value, cond.match, customDimensionValue);
};
